module.exports = __webpack_public_path__ + "static/media/and.a9824d07.svg";